import { DocumentText1, Clock, CloseCircle } from "iconsax-react";
import CheckIcon from "@/shared/assets/icons/CheckIcon";
import type { BadgeColor } from "@/shared/ui";
import type { AmendmentStatus } from "../types";

export const AMENDMENT_STATUS_MAP: Record<
  AmendmentStatus,
  {
    label: string;
    color: BadgeColor;
    icon: React.ReactNode;
  }
> = {
  draft: {
    label: "amendment.statusLabels.draft",
    color: "info",
    icon: <DocumentText1 size={14} color="currentColor" />,
  },
  signing_pending: {
    label: "amendment.statusLabels.signing_pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  app_approved: {
    label: "amendment.statusLabels.app_approved",
    color: "positive",
    icon: <CheckIcon />,
  },
  order_pending: {
    label: "amendment.statusLabels.order_pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  order_uploaded: {
    label: "amendment.statusLabels.order_uploaded",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  agr_pending: {
    label: "amendment.statusLabels.agr_pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  agreement_signed: {
    label: "amendment.statusLabels.agreement_signed",
    color: "positive",
    icon: <CheckIcon />,
  },
  applied: {
    label: "amendment.statusLabels.applied",
    color: "positive",
    icon: <CheckIcon />,
  },
  cancelled: {
    label: "amendment.statusLabels.cancelled",
    color: "negative",
    icon: <CloseCircle size={14} color="currentColor" variant="Bold" />,
  },
};
